import { render, staticRenderFns } from "./CCModalUploadDeliveriesFile.vue?vue&type=template&id=4bf0dfe6"
import script from "./CCModalUploadDeliveriesFile.vue?vue&type=script&lang=js"
export * from "./CCModalUploadDeliveriesFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports